import React, { Component } from 'react';
import { getTranslation } from '../Utilities/GetTranslation.js'

class Loading extends Component {
    render() {
        return (
            <div className="jobwizard-loading">
                <img src="/Search_Selection/assets/images/ripple.gif" alt="Loading" />
                <span>{getTranslation("SNS.JobFinder.Loading")}</span>
            </div>
        );
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/Components/Loading.js